// import React, { useEffect, useRef, useState } from "react";

// // Extracts a clean, short string to ensure the browser's native PDF search/highlighting actually works
// const getSearchPhrase = (raw) => {
//   if (!raw) return "";
//   // Remove markdown, newlines, special characters, and extra spaces
//   const clean = raw
//     .replace(/\\n/g, " ")
//     .replace(/[^a-zA-Z0-9\s]/g, " ")
//     .replace(/\s+/g, " ")
//     .trim();
  
//   // Take the first 5 words. Browsers often fail to highlight if the search string is too long or breaks across pages
//   return clean.split(" ").slice(0, 5).join(" ");
// };

// const SourceViewerModal = ({ source, onClose }) => {
//   const overlayRef = useRef(null);
//   const [visible, setVisible] = useState(false);

//   // Trigger enter animation
//   useEffect(() => {
//     if (source) {
//       requestAnimationFrame(() => setVisible(true));
//     }
//   }, [source]);

//   const handleClose = () => {
//     setVisible(false);
//     setTimeout(onClose, 350);
//   };

//   // Close on overlay click
//   const handleOverlayClick = (e) => {
//     if (e.target === overlayRef.current) handleClose();
//   };

//   // Close on Escape
//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (e.key === "Escape") handleClose();
//     };
//     document.addEventListener("keydown", handleKeyDown);
//     return () => document.removeEventListener("keydown", handleKeyDown);
//   }, []);

//   if (!source) return null;

//   const { file_url, file_name, page, page_content } = source;
//   const pageNum = page ? parseInt(page, 10) : null;
//   const displayPage = pageNum || "—";

//   const searchPhrase = getSearchPhrase(page_content);

//   // Build iframe URL with page fragment and exact search highlighting
//   let iframeSrc = file_url ? `${file_url}#toolbar=0` : "";
//   if (pageNum && file_url) {
//     iframeSrc = `${file_url}#page=${pageNum}`;
//     if (searchPhrase) {
//       // Wrapping in quotes forces exact phrase match in Chrome/Edge native PDF viewers
//       iframeSrc += `&search=${encodeURIComponent(`"${searchPhrase}"`)}`;
//     }
//     iframeSrc += `&toolbar=0`;
//   }

//   return (
//     <div
//       ref={overlayRef}
//       onClick={handleOverlayClick}
//       className="fixed inset-0 z-[999] flex justify-end"
//       style={{
//         backgroundColor: visible ? "rgba(0,0,0,0.35)" : "rgba(0,0,0,0)",
//         transition: "background-color 350ms ease",
//       }}
//     >
//       {/* Slide-in Panel */}
//       <div
//         className="relative flex flex-col bg-white h-full shadow-2xl font-outfit"
//         style={{
//           width: "clamp(500px, 55vw, 900px)",
//           transform: visible ? "translateX(0)" : "translateX(100%)",
//           transition: "transform 350ms cubic-bezier(0.4, 0, 0.2, 1)",
//         }}
//       >
//         {/* Panel Header */}
//         <div className="flex-shrink-0 flex items-center justify-between px-5 py-4 border-b border-gray-200 bg-white z-10">
//           <div className="flex items-center gap-3 min-w-0">
//             {/* PDF Badge */}
//             <div className="w-8 h-8 rounded flex-shrink-0 flex items-center justify-center text-white bg-red-500">
//               <span className="text-[10px] font-bold tracking-wide uppercase">PDF</span>
//             </div>
//             <div className="min-w-0">
//               <p
//                 className="text-sm font-semibold text-[#18101C] truncate max-w-[350px]"
//                 title={file_name}
//               >
//                 {file_name || "Document"}
//               </p>
//               <p className="text-xs text-[#9CA3AF] mt-0.5">
//                 Jumped to Source Page: <span className="text-[#C95EBE] font-semibold">{displayPage}</span>
//               </p>
//             </div>
//           </div>
//           <button
//             onClick={handleClose}
//             className="ml-4 flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 text-gray-500 hover:text-black transition-colors"
//             aria-label="Close"
//           >
//             <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5">
//               <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
//             </svg>
//           </button>
//         </div>

//         {/* Document iframe */}
//         {/* Note: Native browser PDF iframes do not emit scroll/page events to the parent window. */}
//         <div className="flex-1 relative overflow-hidden mx-5 mb-5 mt-4 rounded-xl border border-gray-200 shadow-inner bg-gray-50">
//           <iframe
//             key={iframeSrc}
//             src={iframeSrc}
//             className="w-full h-full border-none rounded-xl"
//             title={`${file_name} - Page ${displayPage}`}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SourceViewerModal;

import React, { useEffect, useRef, useState } from "react";

// Extracts a clean, short string to ensure the browser's native PDF search/highlighting actually works
const getSearchPhrase = (raw) => {
  if (!raw) return "";
  // Remove markdown, newlines, special characters, and extra spaces
  const clean = raw
    .replace(/\\n/g, " ")
    .replace(/[^a-zA-Z0-9\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  
  // Take the first 5 words. Browsers often fail to highlight if the search string is too long or breaks across pages
  return clean.split(" ").slice(0, 5).join(" ");
};

// Helper to get file extension
const getFileExtension = (filename, url) => {
  const target = filename || url || "";
  return target.split(".").pop().toLowerCase().split("?")[0].split("#")[0] || "";
};

const SourceViewerModal = ({ source, onClose }) => {
  const overlayRef = useRef(null);
  const [visible, setVisible] = useState(false);

  // Trigger enter animation
  useEffect(() => {
    if (source) {
      requestAnimationFrame(() => setVisible(true));
    }
  }, [source]);

  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 350);
  };

  // Close on overlay click
  const handleOverlayClick = (e) => {
    if (e.target === overlayRef.current) handleClose();
  };

  // Close on Escape
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") handleClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  if (!source) return null;

  const { file_url, file_name, page, page_content } = source;
  const pageNum = page ? parseInt(page, 10) : null;
  const displayPage = pageNum || "—";
  
  const searchPhrase = getSearchPhrase(page_content);
  const ext = getFileExtension(file_name, file_url);

  // Determine rendering strategy based on file type
  let viewerContent = null;
  let badgeText = "DOC";
  let badgeColor = "bg-gray-500";

  if (ext === "pdf") {
    badgeText = "PDF";
    badgeColor = "bg-red-500";
    
    // Build PDF iframe URL with page fragment and exact search highlighting
    let iframeSrc = file_url ? `${file_url}#toolbar=0` : "";
    if (pageNum && file_url) {
      iframeSrc = `${file_url}#page=${pageNum}`;
      if (searchPhrase) {
        iframeSrc += `&search=${encodeURIComponent(`"${searchPhrase}"`)}`;
      }
      // iframeSrc += `&toolbar=0`;
    }
    
    viewerContent = (
      <iframe
        key={iframeSrc}
        src={iframeSrc}
        className="w-full h-full border-none rounded-xl bg-white"
        title={`${file_name} - Page ${displayPage}`}
      />
    );
  } else if (["xls", "xlsx", "csv"].includes(ext)) {
    badgeText = ext.toUpperCase();
    badgeColor = "bg-green-500";
    const officeUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(file_url)}`;
    viewerContent = (
      <iframe src={officeUrl} className="w-full h-full border-none rounded-xl bg-white" title={file_name} />
    );
  } else if (["doc", "docx", "txt"].includes(ext)) {
    badgeText = ext.toUpperCase();
    badgeColor = "bg-blue-500";
    const officeUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(file_url)}`;
    viewerContent = (
      <iframe src={officeUrl} className="w-full h-full border-none rounded-xl bg-white" title={file_name} />
    );
  } else if (["jpg", "jpeg", "png"].includes(ext)) {
    badgeText = "IMG";
    badgeColor = "bg-purple-500";
    viewerContent = (
      <div className="w-full h-full flex items-center justify-center bg-gray-100 overflow-auto rounded-xl">
        <img src={file_url} alt={file_name} className="max-w-full max-h-full object-contain p-4" />
      </div>
    );
  } else {
    // Fallback using Office viewer
    badgeText = ext ? ext.toUpperCase().substring(0, 4) : "FILE";
    badgeColor = "bg-gray-500";
    const officeUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(file_url)}`;
    viewerContent = (
      <iframe src={officeUrl} className="w-full h-full border-none rounded-xl bg-white" title={file_name} />
    );
  }

  return (
    <div
      ref={overlayRef}
      onClick={handleOverlayClick}
      className="fixed inset-0 z-[999] flex justify-end"
      style={{
        backgroundColor: visible ? "rgba(0,0,0,0.35)" : "rgba(0,0,0,0)",
        transition: "background-color 350ms ease",
      }}
    >
      {/* Slide-in Panel */}
      <div
        className="relative flex flex-col bg-white h-full shadow-2xl font-outfit"
        style={{
          width: "clamp(500px, 55vw, 900px)",
          transform: visible ? "translateX(0)" : "translateX(100%)",
          transition: "transform 350ms cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      >
        {/* Panel Header */}
        <div className="flex-shrink-0 flex items-center justify-between px-5 py-4 border-b border-gray-200 bg-white z-10">
          <div className="flex items-center gap-3 min-w-0">
            {/* Dynamic File Badge */}
            <div className={`w-9 h-9 rounded flex-shrink-0 flex items-center justify-center text-white ${badgeColor}`}>
              <span className="text-[10px] font-bold tracking-wide uppercase">{badgeText}</span>
            </div>
            <div className="min-w-0 flex flex-col justify-center">
              <p
                className="text-sm font-semibold text-[#18101C] truncate max-w-[350px]"
                title={file_name}
              >
                {file_name || "Document"}
              </p>
              {ext === "pdf" && pageNum ? (
                <p className="text-xs text-[#9CA3AF] mt-0.5">
                  Jumped to Source Page: <span className="text-[#C95EBE] font-semibold">{displayPage}</span>
                </p>
              ) : (
                <p className="text-xs text-[#9CA3AF] mt-0.5">
                  Viewing Document
                </p>
              )}
            </div>
          </div>
          <button
            onClick={handleClose}
            className="ml-4 flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 text-gray-500 hover:text-black transition-colors"
            aria-label="Close"
          >
            <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Document Viewer Container */}
        <div className="flex-1 relative overflow-hidden mx-5 mb-5 mt-4 rounded-xl border border-gray-200 shadow-inner bg-gray-100">
          {viewerContent}
        </div>
      </div>
    </div>
  );
};

export default SourceViewerModal;